import { useTemplatesContext } from '../components/Templates/TemplatesContext';
export const useContent = () => {
  const {
    activePage
  } = useTemplatesContext();
  return activePage;
};
//# sourceMappingURL=useContent.js.map